module.exports = __webpack_public_path__ + "static/KonnectzIt-81ff207ccab68d90a7c63bc8ebbdad7e.svg";